<template>
  <div id="pageRoot">
    <div id="tag01" class="tag" style="z-index: 3; top: 50px" ref="tg1">
      <p class="textBase tagText">EL BICHITO PERDIDO.</p>
    </div>
    <div id="tag02" class="tag" style="z-index: 3; top: 110px" ref="tg2">
      <p class="textBase tagText">EL VIOLÍN PERDIDO.</p>
    </div>
    <div id="tag03" class="tag" style="z-index: 3; top: 170px" ref="tg3">
      <p class="textBase tagText">EL VIOLÍN PERFECTO.</p>
    </div>
    <div id="tag04" class="tag" style="z-index: 3; top: 230px" ref="tg4">
      <p class="textBase tagText">EL VIOLÍN BUSCADO.</p>
    </div>

    <img
      src="/pages/img/sordovio/assets_p31/libro_1.png"
      style="position: absolute; width: 520px; top: 170px; left: 100px"
    />

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="pageElement"
      style="z-index: 7"
    />

    <div
      class="textBubble"
      style="
        width: 340px;
        height: 170px;
        left: 660px;
        top: 440px;
        background-color: #ed1c24;
      "
    >
      <div
        class="textContainer textBase center"
        style="width: 90%; height: 90%"
      >
        <p class="center" style="font-size: 30px">
          Escribe el título que señalaste en la tapa del libro.
        </p>
      </div>
      <img
        class="arrow left"
        src="/pages/img/general/textBubbleArrow3.svg"
        style="top: 150px; left: 200px"
      />
    </div>
  </div>
</template>
<style scoped>
.tag {
  position: absolute;
  width: 400px;
  height: 70.55px;
  right: 10px;

  background-image: url(/pages/img/sordo/svgPage71TagLongOFF.svg);
  background-size: cover;
  transform: scale(0.8);
  transition: 0.3s;
  cursor: default;
}
.tag:hover {
  transform: translateY(-10px) scale(0.9);
}
#bg {
  position: absolute;
  left: 48px;
  top: 48px;
}
#inputField01 {
  position: absolute;
  width: 326px;
  height: 30px;
  left: 183px;
  top: 258px;

  font-size: 33px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["vio/Video 102.mp4"],
    };
  },
  computed: {
    dbId() {
      return `${this.$parent.type}-${this.$route.params.chapter}-${
        this.$route.params.number - 1
      }-radios-1`;
    },
  },
  async created() {
    var value = await this.$db.options
      .get({
        id: this.dbId,
      })
      .catch(function (error) {
        console.log("error getting option" + error);
      });
    if (value === undefined) return;
    console.log("loaded value");
    console.log(value);

    if (value.option === 1) {
      this.$refs.tg1.style["background-image"] =
        "url(/pages/img/sordo/svgPage71TagLong.svg)";
    } else if (value.option === 2) {
      this.$refs.tg2.style["background-image"] =
        "url(/pages/img/sordo/svgPage71TagLong.svg)";
    } else if (value.option === 3) {
      this.$refs.tg3.style["background-image"] =
        "url(/pages/img/sordo/svgPage71TagLong.svg)";
    } else {
      this.$refs.tg4.style["background-image"] =
        "url(/pages/img/sordo/svgPage71TagLong.svg)";
    }
  },
};
</script>